import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { GreenCircleOutlineSvg } from 'apps/sigma2-ui/src/components/svg/GreenCircleOutline';
import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { GreenCheckmarkWithCircleSvg } from 'apps/sigma2-ui/src/components/svg/GreenCheckmarkWithCircle';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DataSetCompositeCompleteIndicator = () => {
  const language = useLanguage();

  return (
    <Spacing size={'md'} direction={'vertical'} className={'items-center'}>
      <GreenCheckmarkWithCircleSvg />
      <S2Typography
        variant={'headline-5-alt'}
        translatedContent={language.dangerousUserInput({
          value: 'Complete',
        })}
      />
    </Spacing>
  );
};
